module.exports = __webpack_public_path__ + "media/images/lp_reason-2-b1a41774c028daafd97b2ff310daeec3.webp";